<template>
  <div>
    <!-- 服务商 -->
    <div class="detail-wrap">
      <el-form ref="editForm" :model="formData">
        <div class="d-header">
          <div class="fl">
            <i class="el-icon-info"/>
            查看流水
          </div>

        </div>

        <div>

          <div class="goodsStatus">
            <div v-for="(item, index) in goodsStatusList" :key="index">
              <div :class="{
											btnGoodsStatusBt1: goodsStatusIndex == item.t,
											btnGoodsStatusBt: goodsStatusIndex != item.t,
										}" @click="changeGoodsStatus(item, item.t)">
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
          <div>

            <div style="height: calc(100vh - 155px);">
              <vxe-table ref="filterTable" :data="details"
                         style="margin: 10px auto; " :stripe="true"
                         :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                         :row-config="{height: 30,isHover: true,padding: 0,}" :row-style="{ fontSize: '12px',  }"
                         show-overflow height="90%" :column-config="{ resizable: true }">
                <vxe-column type="seq" width="55"/>
                <vxe-column field="checkDate" title="时间" width="200"/>
                <vxe-column field="qty" title="业务数量" width="100">
                  <template #default="{row}">
                    <span>{{row.symbol}}{{row.qty}}</span>
                  </template>
                </vxe-column>
                <vxe-column field="business" title="业务" width="100"/>
                <vxe-column field="invoicesNo" title="业务单据" width="180"/>
                <vxe-column field="remark" title="备注"/>
                <vxe-column field="checkBy" title="操作人" width="100"/>
              </vxe-table>

              <pager style="float: left" ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </div>
          </div>
        </div>
      </el-form>
      <!-- 服务区域弹窗表 -->
    </div>

  </div>
</template>
<script>
import Tinymce from '@/components/Tinymce';
import api from "@/api/projectApi";
import pager from "@/components/pager/index.vue";


export default {
  name: 'edit',
  props: {
    _dataId: [String, Number],
    _nums: [String, Number],
    type: [String],
    multiple: true,
  },
  components: {
    pager,
    Tinymce,
  },
  data() {
    return {
      total: 0,
      goodsStatusList: [ //循环列表
        {name: "库存流水", num: 2, t: 1},
        {name: "占用库存流水", num: 3, t: 2},
      ],
      goodsStatusItem: "",//获取点击的元素名称
      goodsStatusIndex: 1,//:class做判断用，默认选中第一个
      pageSizes: [50, 100, 500],
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
        id: this._dataId,
        type: '库存流水',
      },
      details: [],
    }
  },
  computed: {

  },
  created() {
    if (this.type) {
      this.requestParam.type = this.type
      if (this.type == '占用库存流水') {
        this.goodsStatusIndex = 2
      }
    } else {
      this.requestParam.type = '库存流水'
    }
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
  },
  mounted() {

  },
  methods: {
    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData()
    },

    getTableData() {
      this.$mask.open()

      this.$http({
        url: api.spPartsInv.getDetailsUrl,
        method: 'post',
        data: this.requestParam
      }).then(res => {
        let data = res.data.data;
        console.log(data, 'data')
        this.details = data.records
        this.total = data.total
      })
      this.$mask.close()

    },

    // 选中的按钮
    changeGoodsStatus(item, t) {
      this.$mask.open()

      console.log(item, t, "item, t的值是？？？？");
      this.goodsStatusItem = item.name;//获取点击的元素
      this.goodsStatusIndex = t;//将点击元素的下标和：class中的作对比

      this.requestParam.type = item.name
      this.getTableData()
      this.$mask.close()

    },




  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-step__title {
  font-size: 11px;
  line-height: 25px;
}

#containt .detail-wrap .d-cont .d-item {
  padding: 5px 0 !important;
}

.gather .el-tab-pane {
  margin-top: 10px;
  padding: 20px 0;

  >>>.el-tabs__active-bar {
    left: 20px !important;
  }

  .el-tabs__nav {
    margin-left: 20px !important;
  }
}

#containt .title b {
  margin-left: 0px !important;
}

::v-deep .product th:after {
  display: none !important;
}

::v-deep .product td {
  padding: 5px 0 !important;

}

::v-deep .vxe-table--render-default .vxe-cell {
  text-align: left !important;
}

.el-image {
  border: dashed 1px #e2e2e2;
  margin-right: 20px;
}

.undergo {
  ::v-deep .el-card.is-always-shadow {
    background-color: #f2f2f2;
    position: relative;
  }

  .el-timeline {
    background-color: #fff;
    padding-left: 10px !important;
    height: 100% !important;
  }

  .el-image {
    width: 60px !important;
    height: 60px !important;
  }

}

::v-deep .el-select__tags > span {
  display: flex !important;;
}

// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBt {
  //白底按钮
  // width: 100px;
  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}
</style>
